import { AnyAction } from 'redux';
import { PRICE_HISTORY_SET_MODAL_OPEN } from '../constants';

interface PriceHistory {
  modalOpen: boolean;
  previouslyLowestPrice: string;
  numberOfDays: number;
  description: string;
  title: string;
}

const DEFAULT_STATE: PriceHistory = {
  modalOpen: false,
  previouslyLowestPrice: '0',
  numberOfDays: 30,
  description: '',
  title: '',
};

export const priceHistory = (
  state = DEFAULT_STATE,
  action: AnyAction
): PriceHistory => {
  switch (action.type) {
    case PRICE_HISTORY_SET_MODAL_OPEN:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
